/* eslint-disable jsx-a11y/interactive-supports-focus */
import { format, getHours, isSameDay, setHours } from "date-fns";
import en from "date-fns/locale/en";
import pl from "date-fns/locale/pl";
import Carousel from "nuka-carousel";
import { sort } from "ramda";
import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { degToWind } from "../../../services/helpers/weather";
import { ArrowIcon, WeatherIcon, Button } from "../../common/index";

const getSlideIndex = (value, length) => {
  if (length <= 8) {
    return 0;
  }
  if (value >= 16) {
    return 16;
  }
  if (value >= 8) {
    return 8;
  }
  return 0;
};

const getSlideshowConfig = length => {
  const pageCount = Math.round(length / 8);
  const slidesToScroll = Math.abs(length / pageCount);
  return {
    slidesToScroll,
  };
};

const langs = {
  pl,
  gb: en,
};

const isCurrentHour = (hour, date) => getHours(hour) === getHours(date);

// const getWeekDay = (i, day, lang) => {
//   if (i === 0) {
//     // eslint-disable-next-line
//     return lang == "pl" ? "Dziś" : "Today";
//   }
//   if (i === 1) {
//     // eslint-disable-next-line
//     return lang == "pl" ? "Jutro" : "Tomorrow";
//   }
//   return format(day, "dddd", { locale: langs[lang] });
// };

// const byTemperature = (a, b) => a.temperature - b.temperature;

// const getMinTemperature = weather => Number(weather[0].temperature).toFixed(0);
// const getMaxTemperature = weather =>
//   Number(weather[weather.length - 1].temperature).toFixed(0);

const getForecast = (forecast, date) => {
  const find = forecast.weather_hourly.find(
    weather => weather.hour === getHours(date)
  );

  if (!find) {
    return forecast.weather_hourly[0];
  }

  return find;
};

const getWeather = (forecast, date) =>
  forecast.find(weather => isSameDay(date, weather.at_date));

export const getWeatherIconName = (weatherHourlyList = []) => {
  const sortedWeatherHourlyList = sort(
    (weatherA, weatherB) => weatherB.hour - weatherA.hour,
    weatherHourlyList
  );
  try {
    if (sortedWeatherHourlyList.length === 24) {
      return sortedWeatherHourlyList[sortedWeatherHourlyList.length / 2 - 1]
        .icon_processed;
    }
    return sortedWeatherHourlyList[0].icon_processed;
  } catch (e) {
    return "partly-cloudy-day";
  }
};

export const getTemperature = (weatherHourly = []) => {
  const sortedWeatherHourly = JSON.parse(JSON.stringify(weatherHourly)).sort(
    (a, b) => a.hour - b.hour
  );

  if (sortedWeatherHourly.length <= 2) {
    return {
      day: sortedWeatherHourly.shift().temperature.toFixed(0),
      night: sortedWeatherHourly.pop().temperature.toFixed(0),
    };
  }

  return {
    day: sortedWeatherHourly
      .slice(0, (sortedWeatherHourly.length - 1) / 2)
      .shift()
      .temperature.toFixed(0),
    night: sortedWeatherHourly.pop().temperature.toFixed(0),
  };
};

const getNextAndPreviousDate = (forecast = [], day = new Date()) => {
  const days = forecast.reduce(
    (prev, curr, index) => {
      if (curr.at_date.toISOString() === day.toISOString()) {
        return {
          current: curr,
          next: index === forecast.length ? null : forecast[index + 1],
          previous: index === 0 ? null : forecast[index - 1],
        };
      }

      return prev;
    },
    {
      next: null,
      previous: null,
      current: null,
    }
  );

  return days;
};

class Property extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDay: props.selectedDay,
      currentDate: new Date(),
    };
  }

  changeCurrentDate = (date, hours) => {
    const { currentDate } = this.state;
    if (getHours(currentDate) > hours.length + 1) {
      return this.setState({
        currentDate: setHours(currentDate, hours[0].hour),
        selectedDay: date,
      });
    }
    return this.setState({
      selectedDay: date,
    });
  };

  render() {
    const { forecast } = this.props.data;
    const { selectedDay, currentDate } = this.state;
    const selectedForecast = getWeather(forecast, selectedDay);

    const {
      rain_chance,
      rain_amount,
      humidity,
      wind_speed,
      icon_processed,
      wind_direction,
      soil_temperature_layer_1,
      soil_temperature_layer_2,
      soil_temperature_layer_3,
      soil_temperature_layer_4,
      soil_moisture_content_layer_1,
      soil_moisture_content_layer_2,
      soil_moisture_content_layer_3,
      soil_moisture_content_layer_4,
      evaporation_from_soil_surface,
    } = getForecast(selectedForecast, currentDate);

    const { t, i18n, onBack } = this.props;

    const days = getNextAndPreviousDate(forecast.slice(0, 5), selectedDay);

    return (
      <Fragment>
        <div className="weather-widget__property">
          <div className="weather-widget__property__next">
            <div className="previous">
              {!!days.previous && (
                <Button
                  buttonsize="small"
                  buttoncolor="yellow"
                  onClick={() => {
                    this.changeCurrentDate(
                      days.previous.at_date,
                      days.previous.weather_hourly
                    );
                  }}
                >
                  <ArrowIcon color="black" />
                  {format(days.previous.at_date, "dddd", {
                    locale: langs[i18n.language],
                  })}
                </Button>
              )}
            </div>
            <div className="next">
              {!!days.next && (
                <Button
                  buttonsize="small"
                  buttoncolor="yellow"
                  onClick={() => {
                    this.changeCurrentDate(
                      days.next.at_date,
                      days.next.weather_hourly
                    );
                  }}
                >
                  {format(days.next.at_date, "dddd", {
                    locale: langs[i18n.language],
                  })}
                  <ArrowIcon color="black" />
                </Button>
              )}
            </div>
          </div>
          <div className="weather-widget__property__current_day">
            <h6>
              {format(selectedDay, "dddd", {
                locale: langs[i18n.language],
              })}
            </h6>
            <div className="temperature__wrapper">
              <div className="temperature">
                {typeof selectedForecast.average_daytime_temperature ===
                  "number" && (
                  <p>
                    {t("tools:weather.day")}:{" "}
                    <b>
                      {Math.round(selectedForecast.average_daytime_temperature)}
                      °C
                    </b>
                  </p>
                )}
                {typeof selectedForecast.average_nighttime_temperature ===
                  "number" && (
                  <p>
                    {t("tools:weather.night")}:{" "}
                    <b>
                      {Math.round(
                        selectedForecast.average_nighttime_temperature
                      )}
                      °C
                    </b>
                  </p>
                )}
              </div>
              <WeatherIcon
                forecast={icon_processed}
                size={96}
                color="#00965E"
              />
            </div>
          </div>
          <div className="weather-widget__property__forecast">
            <Carousel
              dragging={false}
              slidesToShow={8}
              slidesToScroll={
                getSlideshowConfig(selectedForecast.weather_hourly.length)
                  .slidesToScroll
              }
              slideIndex={getSlideIndex(
                getHours(currentDate),
                selectedForecast.weather_hourly.length
              )}
              renderBottomCenterControls={() => null}
              renderCenterLeftControls={({ previousSlide, currentSlide }) => (
                <ArrowIcon
                  color={
                    getSlideIndex(
                      currentSlide,
                      selectedForecast.weather_hourly.length
                    ) === 0
                      ? "#F2F2F2"
                      : "black"
                  }
                  onClick={previousSlide}
                />
              )}
              renderCenterRightControls={({ nextSlide, currentSlide }) => (
                <ArrowIcon
                  color={
                    getSlideIndex(
                      currentSlide,
                      selectedForecast.weather_hourly.length
                    ) >=
                    (selectedForecast.weather_hourly.length / 3) * 2
                      ? "#F2F2F2"
                      : "black"
                  }
                  onClick={nextSlide}
                />
              )}
            >
              {sort(
                (a, b) => a.hour - b.hour,
                selectedForecast.weather_hourly
              ).map(weather => {
                const day = setHours(selectedForecast.at_date, weather.hour);
                return (
                  <div
                    key={weather.at_date}
                    role="button"
                    onClick={() =>
                      this.setState({
                        currentDate: day,
                      })
                    }
                    className={`day ${isCurrentHour(day, currentDate) &&
                      "current"}`}
                  >
                    <WeatherIcon
                      forecast={weather.icon_processed}
                      size={46}
                      color={
                        isCurrentHour(day, currentDate) ? "#FFA203" : "#9B9B9B"
                      }
                    />
                    <div>{format(day, "H:00")}</div>
                  </div>
                );
              })}
            </Carousel>
          </div>
          <div className="weather-widget__property__info">
            <div>
              <h6>{t("tools:weather.conditions")}:</h6>
              <p>
                {t("tools:weather.rain")}: <b>{rain_chance}%</b>
              </p>
              <p>
                {t("tools:weather.rain2")}: <b>{rain_amount} mm/h</b>
              </p>
              <p>
                {t("tools:weather.wind")}:{" "}
                <b>
                  {degToWind(wind_direction)}, {wind_speed} m/s
                </b>
              </p>
              <p>
                {t("tools:weather.humidity")}: <b>{humidity} %</b>
              </p>
            </div>
            <div>
              <h6>{t("tools:weather.soil")}:</h6>
              <p>
                {t("tools:weather.soilTemperature")}: <br />
                <b>
                  15cm: {soil_temperature_layer_1}°C | 25cm:{" "}
                  {soil_temperature_layer_2}°C <br />
                  60cm: {soil_temperature_layer_3}°C | 2m:{" "}
                  {soil_temperature_layer_4}°C
                </b>
              </p>
              <p>
                {t("tools:weather.soilMoisture")}: <br />
                <b>
                  15cm: {soil_moisture_content_layer_1} % | 25cm:{" "}
                  {soil_moisture_content_layer_2} % <br />
                  60cm: {soil_moisture_content_layer_3} % | 2m:{" "}
                  {soil_moisture_content_layer_4} %
                </b>
              </p>
              <p>
                {t("tools:weather.evaporation")}:{" "}
                <b>{evaporation_from_soil_surface} kg/m2/h</b>
              </p>
            </div>
          </div>
          <div className="weather-widget__property__back">
            <Button buttonsize="small" buttoncolor="green" onClick={onBack}>
              {t("tools:weather.back")}
            </Button>
          </div>
        </div>
      </Fragment>
    );
  }
}

Property.propTypes = {};
Property.defaultProps = {};

export default withTranslation(["tools"])(Property);
